// extracted by mini-css-extract-plugin
export default {"onboarding":"styles_onboarding__K1BBp","body":"styles_body__LJCzW","table-body":"styles_table-body__STnin"};